export default {
  eyebrow: 'Level up',
  title: 'Get the most from your money',
  description:
    'Discover what you need to master your money with a NerdWallet account. See the big picture, receive tailored insights and get clear next steps — all in one place.',
  videoSrc: 'https://www.nerdwallet.com/cdn/homepage/animations/membership.mp4',
  posterSrc:
    'https://www.nerdwallet.com/cdn/homepage/animations/membership-poster.png',
  ctaText: 'Sign up',
  trkCopy: 'nwacct_signup_greendot',
};
